export const WA_NUMBER = '6281805023857';